import { render, staticRenderFns } from "./AttendOrdersComponent.vue?vue&type=template&id=aaecde9e&scoped=true&"
import script from "./AttendOrdersComponent.vue?vue&type=script&lang=js&"
export * from "./AttendOrdersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaecde9e",
  null
  
)

export default component.exports